import { Switch } from '@thanx/uikit/switch'
import { buildTranslate } from 'locales'
import isEmpty from 'lodash/isEmpty'

import { useFormModel } from '../../FormModel'
import NotPurchase from './NotPurchase'

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.online_redemption_card'
)

const ItemRedemption = () => {
  const {
    onlineDiscountedProductIds,
    onlineRequiredProductIds,
    onlineDiscountedModifierIds,
    typeItem,
  } = useFormModel()?.model || {}

  const itemSubtype = typeItem?.subtype

  const displayDiscountedProducts =
    itemSubtype === 'item' ||
    itemSubtype === 'bogo/item' ||
    (itemSubtype === null && !isEmpty(onlineDiscountedProductIds))
  const displayRequiredProducts =
    itemSubtype === 'bogo/item' ||
    itemSubtype === 'bogo/purchase' ||
    (itemSubtype === null && !isEmpty(onlineRequiredProductIds))

  return (
    <>
      <Switch
        condition={typeItem?.subtype !== 'purchase'}
        fallback={<p className="grey-70">{t('will_be_able_to_redeem')}</p>}
      >
        <NotPurchase
          discountedModifierIds={onlineDiscountedModifierIds}
          discountedProductIds={onlineDiscountedProductIds}
          requiredProductIds={onlineRequiredProductIds}
          typeItem={typeItem}
        />
      </Switch>
      <Switch condition={displayRequiredProducts && !displayDiscountedProducts}>
        <p className="body-text-14 bold">{t('then_entire_purchase')}</p>
      </Switch>
    </>
  )
}

export default ItemRedemption
